import { PHONE_HREF, PHONE_NUMBER } from '~/shared/components/footer/constants';
import NextLink from '~/shared/components/link';
import Subscription from '~/shared/components/subscription';
import { type Locale, PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { useTypedTranslation } from '~/shared/hooks';

import './footer-legal-links.scss';

type FooterLegalLinksProps = Readonly<{
  lng: Locale;
}>;

const FooterLegalLinks = ({ lng }: FooterLegalLinksProps) => {
  const t = useTypedTranslation(['text', 'link']);
  const ofertaLabel = t('text.oferta-contract');
  const privacyPolicyLabel = t('text.privacy-policy');

  return (
    <section className="footer-legal-links">
      <div className="footer-legal-links__content-container">
        <div className="footer-legal-links__cta-block">
          <div className="footer-legal-links__links-block">
            <NextLink
              href={getLocaleLink(PAGE_NAMES.OUR_STATUTE, lng)}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-legal-links__mail"
            >
              {ofertaLabel}
            </NextLink>

            <NextLink
              href={getLocaleLink(PAGE_NAMES.PRIVACY_POLICY, lng)}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-legal-links__support"
            >
              {privacyPolicyLabel}
            </NextLink>
          </div>

          <div className="footer-legal-links__links-block">
            <div className="footer-legal-links__phone-text">{t('text.phone')}</div>
            <a className="footer-legal-links__phone-number" href={PHONE_HREF}>
              {PHONE_NUMBER}
            </a>
          </div>

          <div className="footer-legal-links__links-block">
            <a className="footer-legal-links__mail" href="mailto:mail@prana.club.service.gmail.com">
              {t('text.our-email')}
            </a>

            <NextLink className="footer-legal-links__support" href={getLocaleLink(PAGE_NAMES.SUPPORT, lng)}>
              {t('text.support')}
            </NextLink>
          </div>
          <div className="footer-legal-links__links-block">
            <Subscription lng={lng} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FooterLegalLinks;
